/* @flow */
import React, { Component } from 'react'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {elastic as Menu} from 'react-burger-menu'

import './HeaderContainer.css'
import logo from '../../images/Novo_Logo.svg'
import whitepaper from '../../files/novo_whitepaper.pdf'

type Props = {
	changePage: Function,
}

class HeaderContainer extends Component<Props> {

	headerNav = () => {
		return(
			<div className="header-nav--container">
				<nav className="header--nav">
					<ul className="header--nav--list">
						<li className="header--nav--list-item"><a href="#use_cases">USE CASES</a></li>
						<li className="header--nav--list-item"><a href="#about">ABOUT</a></li>
						<li className="header--nav--list-item"><a href="#roadmap">ROADMAP</a></li>
						<li className="header--nav--list-item"><a href="#team">TEAM</a></li>
						<li className="header--nav--list-item"><a href={whitepaper} target="_blank">WHITEPAPER</a></li>
					</ul>
				</nav>
				<div className="header--cta">
					<div className="social-buttons--list">
							<a href="https://twitter.com/rye_labs" target="_blank" className="social-button social-button--twitter">
								<span><i className="icon icon-twitter" /></span>
							</a>
							{/*<a href="https://discord.gg/YsDM84n" target="_blank" className="social-button social-button--discord">
								<span><i className="icon icon-discord" /></span>
							</a>*/}
							<a href="https://www.medium.com/NovoProtocol" target="_blank" className="social-button social-button--medium">
								<span><i className="icon icon-medium-m" /></span>
							</a>
					</div>
				</div>
			</div>
		)
	}

  render() {
    return (
			<header>
				<div className="header container">
					<div className="header--logo">
						<a href="/">
							<img src={logo}/>
						</a>
					</div>
					<div className="header-menu--container">
						<div className="header-menu--full">
							{this.headerNav()}
						</div>
						<div className="header-menu--slide">
							<Menu right className={"hamburger-menu"} bodyClassName={ "overlay-open" } pageWrapId={ "page-wrapper" } outerContainerId={ "App" }>
								{this.headerNav()}
							</Menu>
						</div>
					</div>
				</div>
			</header>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: (path) => push(path)
}, dispatch)

export default connect(null, mapDispatchToProps)(HeaderContainer)



// WEBPACK FOOTER //
// ./src/App/HeaderContainer/HeaderContainer.js